import React, { useState, useEffect, useRef } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Permission.css";
import Modal from "react-modal";
import { useLocation, useNavigate } from "react-router-dom";
import Switch from "react-switch";
import { toast, ToastContainer } from "react-toastify";
import Pajination from "../../helpingFiles/Pagination/Pajination";
import SideBar from "../../Components/Navbar/Sidebar";
import instance from "../../Components/Apis/axios";
import Head from "../../Components/ontabletop/head";
Modal.setAppElement("#root");

const StaffPermission = () => {
  const [roleList, setRoleList] = useState([]);
  const [posts, setPosts] = useState([]);
  const [modalisopen, setmodalisopen] = useState(false);
  const [edit, setedit] = useState(false);
  const [user, setUser] = useState({
    name: "",
    password: "",
    confirmPassword: "",
    firstname: "",
    lastname: "",
    email: "",
    phonenumber: "",
    role: "",
  });
  const [permission, setPermission] = useState([]);
  const [query, setQuery] = useState("");
  const [total, setTotal] = useState([]);
  const [page, setPage] = useState(1);
  const [postPerpage, setPostPerPage] = useState(10);
  const navigation = useNavigate();
  const locations = useLocation();
  const path = locations.pathname;
  const changehandler = (e) => {
    setUser({ ...user, [e.target.name]: e.target.value });
  };

  // functin for hge toggle funtionality
  const toggle = async (id) => {
    const { data } = await instance.post(`staff/toggle?path=${path}`, {
      id: id,
    });
    if (data.message == "You are not authorized for this Action") {
      alert(data.message);
    } else {
      setPosts(data);
    }
  };

  const updateuser = async (e, id) => {
    e.preventDefault();
    const { data } = await instance.post(`staff/update?path=${path}`, {
      id: id,
      email: user.email,
      password: user.password,
      role: user.name,
    });
    if (data.message == "You are not authorized for this Action") {
      alert(data.message);
    } else {
      getDATA();
      setedit(false);
      toast(data.message);
    }
  };

  const handleClick = (event) => {
    let data = [...permission];
    data.forEach((element) => {
      if (event.currentTarget.checked) {
        if (element.permissionid == event.currentTarget.id) {
          element[event.currentTarget.value] = 1;
          setPermission(data);
        }
      } else {
        if (element.permissionid == event.currentTarget.id) {
          element[event.currentTarget.value] = 0;
          setPermission(data);
        }
      }
    });
  };

  const updatePermission = async () => {
    const { data } = await instance.post(
      `staff/updatePermission?path=${path}`,
      {
        permission: permission,
        role: user.role,
        staffid: user.staffid,
      }
    );
    if (data.message == "You are not authorized for this Action") {
      alert(data.message);
    } else {
      getDATA();
      toast("User`s  permission updated successfully");
      setedit(false);
    }
  };

  const changeFunc = async (staff, role) => {
    const { data } = await instance.post(`staff/rolePermission?path=${path}`, {
      roleid: role,
      staffid: staff,
    });
    if (data.message == "You are not authorized for this Action") {
      alert(data.message);
    } else {
      setPermission(data);
    }
  };

  const indexOfLastPage = page * postPerpage;
  const indexOfFirstPage = indexOfLastPage - postPerpage;
  const currentPosts =
    posts.length > 0 && posts.slice(indexOfFirstPage, indexOfLastPage);

  const getDATA = async () => {
    const { data } = await instance.get(`staff/list?path=${path}`);
    if (data.message == "You are not authorized for this page") {
      navigation("/");
    } else {
      setPosts(data);
      setTotal(data.length);
    }
  };

  const getRoles = async () => {
    const { data } = await instance.get(`staff/rolePermission?path=${path}`);
    if (data.message == "You are not authorized for this page") {
      navigation("/");
    } else {
      setRoleList(data);
    }
  };

  useEffect(() => {
    getDATA();
    getRoles();
  }, []);

  const createUser = async (e) => {
    e.preventDefault();
    const { data } = await instance.post(`staff/list?path=${path}`, { user });

    if (data.message == "User created") {
      getDATA();
      toast("User created successfully");
      setmodalisopen(false);
    } else {
      alert(data.message);
    }
  };

  const mediaRef = useRef(null);
  const mediaCompanyRef = useRef(null);

  const mediaFormRef = useRef(null);
  const mediaCompanyFormRef = useRef(null);

  const switchTab = (tab) => {
    if (tab === "media") {
      mediaFormRef.current.classList.remove("userProfileHidden");
      mediaCompanyFormRef.current.classList.add("userProfileHidden");

      mediaRef.current.classList.add("navActive");
      mediaCompanyRef.current.classList.remove("navActive");
    }

    if (tab === "company") {
      mediaFormRef.current.classList.add("userProfileHidden");
      mediaCompanyFormRef.current.classList.remove("userProfileHidden");

      mediaRef.current.classList.remove("navActive");
      mediaCompanyRef.current.classList.add("navActive");
    }
  };

  return (
    <div className="containers">
      <div className="container-sidebar">
        <SideBar />
      </div>
      <div className="container-pages row">
        <div className="col-6 page-title">
          <h2>Staff Permission</h2>
        </div>
        <div className="col-6 page-title">
          <button className="create_usr" onClick={() => setmodalisopen(true)}>
            Create User
          </button>
        </div>
        <Head setPostPerPage={setPostPerPage} setQuery={setQuery} />
        <Modal isOpen={modalisopen} className="form_modal w-75 mt-4">
          <button className="closeToggle" onClick={() => setmodalisopen(false)}>
            <i className="fa-solid fa-multiply text-danger"></i>
          </button>
          <form className="right info" onSubmit={(e) => createUser(e)}>
            <div className="inputs">
              <div className="infoInput">
                <div className="input">
                  <i className="fa-solid fa-user"></i>
                  <input
                    autoComplete="off"
                    name="firstname"
                    type="text"
                    value={user.firstname}
                    onChange={changehandler}
                    placeholder="First Name"
                    required
                  />
                </div>
              </div>
              <div className="infoInput">
                <div className="input">
                  <i className="fa-solid fa-user"></i>
                  <input
                    autoComplete="off"
                    name="lastname"
                    type="text"
                    value={user.lastname}
                    onChange={changehandler}
                    placeholder="Last Name"
                    required
                  />
                </div>
              </div>
              <div className="infoInput">
                <div className="input">
                  <i className="fa-solid fa-user"></i>
                  <input
                    autoComplete="off"
                    name="email"
                    type="email"
                    value={user.email}
                    onChange={changehandler}
                    placeholder="User Email"
                    required
                  />
                </div>
              
              </div>
              <div className="infoInput">
                <div className="input">
                  <i className="fa-solid fa-user"></i>
                  <input
                    autoComplete="off"
                    name="phonenumber"
                    type="tel"
                    value={user.phonenumber}
                    onChange={changehandler}
                    placeholder="User Phonenumber"
                    required
                  />
                </div>
              </div>
              <div className="infoInput">
                <div className="input">
                  <i className="fa-solid fa-lock"></i>{" "}
                  <input
                    autoComplete="off"
                    type="password"
                    name="password"
                    value={user.password}
                    onChange={changehandler}
                    placeholder="password"
                    required
                  />
                </div>
              </div>
              <div className="infoInput">
                <div className="input">
                  <i className="fa-solid fa-lock"></i>{" "}
                  <input
                    autoComplete="off"
                    type="password"
                    name="confirmPassword"
                    value={user.confirmPassword}
                    onChange={changehandler}
                    placeholder="password"
                    required
                  />
                </div>
              </div>
              <div className="infoInput">
                <div className="select-input">
                  <select id="selectBox" name="role" onChange={changehandler}>
                    {/* <option  selected disabled={true}>Change Role</option> */}
                    {roleList.length > 0 &&
                      roleList.map((obj, i) => (
                        <option value={obj.roleid}>{obj.name}</option>
                      ))}
                  </select>
                </div>
              </div>
            </div>
            <input type="submit" value="Create" className="float-right" />
         
          </form>
        </Modal>
        <table className="table table-boarder table-hover table-striped table-sm">
          <thead className="thead-dark">
            <tr className="text-center">
              <th>ID</th>
              <th>Name</th>
              <th>Email</th>
              {/* <th>Password</th> */}
              <th>Role</th>
              <th>Edit</th>
              <th>Active</th>
            </tr>
          </thead>
          <tbody>
            {/* map funtion on all data */}
            {currentPosts.length > 0 &&
              currentPosts
                .filter((obj) => {
                  if (query == "") {
                    return obj;
                  } else if (
                    obj.password.toLowerCase().includes(query.toLowerCase()) ||
                    obj.email.toLowerCase().includes(query.toLowerCase()) ||
                    obj.role.toLowerCase().includes(query.toLowerCase())
                  ) {
                    return obj;
                  }
                })
                .map((obj, i) => (
                  <tr key={i}>
                    <td>{obj.staffid}</td>
                    <td>{obj.firstname}</td>
                    <td>{obj.email}</td>
                    {/* <td>{obj.password}</td> */}
                    <td>{obj.name}</td>
                    {/* opening model for a specific user by identify te id */}
                    <td>
                      {" "}
                      <button
                        className="button show-btn"
                        onClick={() => {
                          setedit(true);
                          setUser(obj);
                        }}
                      >
                        Edit
                      </button>{" "}
                    </td>
                    <td>
                      <Switch
                        onChange={() => toggle(obj.staffid)}
                        checked={obj.active == 0 ? true : false}
                      />
                    </td>
                  </tr>
                ))}
          </tbody>
        </table>
        <div>
          {/* Edit profile Model */}

          <Modal isOpen={edit} className="form_modal w-75 mt-4">
            <div
              className="permissionFilter"
              style={{ justifyContent: "center" }}
            >
              <div
                className="navActive"
                ref={mediaRef}
                onClick={(e) => switchTab("media")}
              >
                <strong>Information</strong>
              </div>
              <div ref={mediaCompanyRef} onClick={(e) => switchTab("company")}>
                <strong onClick={(i, w) => changeFunc(user.staffid, user.role)}>
                  Permission
                </strong>
              </div>
            </div>
            <button className="closeToggle" onClick={() => setedit(false)}>
              <i className="fa-solid fa-multiply"></i>
            </button>
            <form
              className="right info "
              onSubmit={(e) => updateuser(e, user.staffid)}
              ref={mediaFormRef}
            >
              <div className="inputs">
                <div className="infoInput">
                  <label htmlFor="password">Email</label>
                  <div className="input">
                    <i className="fa-solid fa-user"></i>
                    <input
                      className="input"
                      type="email"
                      placeholder="Email"
                      name="email"
                      value={user.email}
                      onChange={(e) => changehandler(e)}
                    />
                  </div>
                </div>
                <div className="infoInput">
                  <label htmlFor="password">Password</label>
                  <div className="input">
                    <i className="fa-solid fa-lock"></i>
                    <input
                      className="password"
                      type="password"
                      placeholder="Password"
                      name="password"
                      value={user?.password}
                      onChange={(e) => changehandler(e)}
                    />
                  </div>
                </div>

                <div className="infoInput">
                  <label>Role:</label>
                  <div className="select-input">
                    <select
                      onChange={(e) => {
                        changehandler(e);
                        // changeFunc(e);
                      }}
                      className="input"
                      name="name"
                      value={user.name}
                    >
                      {roleList.map((obj, i) => (
                        <option value={obj.name} key={i}>
                          {obj.name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <input type="submit" value="Update User" className="p-2  " />
                </div>
              </div>
            </form>
            <div className="container">
              <div>
                <div className="navActive userProfileHidden">
                  <form onSubmit={(e) => updateuser(e, user.id)}>
                    <div className="field m-2 p-2">
                      <label>Email</label>
                      <input
                        className="input"
                        type="text"
                        placeholder="Email"
                        name="email"
                        value={user.email}
                        onChange={(e) => changehandler(e)}
                        required
                      />
                    </div>

                    <div className="field m-2 p-2">
                      <label>Password</label>
                      <input
                        className="input"
                        type="text"
                        placeholder="Password"
                        name="password"
                        value={user.password}
                        onChange={(e) => changehandler(e)}
                        required
                      />
                    </div>
                    <div className="field m-2 p-2">
                      <label>Role</label>
                      <select
                        id="selectBox"
                        onChange={(e) => {
                          changehandler(e);
                          // changeFunc(e);
                        }}
                        className="input"
                        name="role"
                        value={user.role}
                      >
                        {roleList.map((obj, i) => (
                          <option value={obj.role}>{obj.role}</option>
                        ))}
                      </select>
                    </div>
                    <div className="field m-2 p-2">
                      <h3>{user.mess}</h3>
                    </div>
                    <input type="submit" />
                  </form>
                </div>
                <div
                  className="permissionRole userProfileHidden"
                  ref={mediaCompanyFormRef}
                >
                  <form onSubmit={updatePermission}>
                    <table className="table table-boarder table-hover table-striped table-sm ">
                      <thead>
                        <tr className="text-center">
                          <th>ID</th>
                          <th>Permissionid</th>
                          <th>Can_View</th>
                          <th>Can_View_Own</th>
                          <th>Can_Edit</th>
                          <th>Can_Create</th>
                          <th>Can_Delete</th>
                        </tr>
                      </thead>
                      <tbody>
                        {permission.map((item, i) => (
                          <tr key={i}>
                            <td>{i + 1}</td>
                            <td>{item.name}</td>
                            <td>
                              <input
                                type="checkbox"
                                id={item.permissionid}
                                value="can_view"
                                checked={item.can_view || false}
                                onChange={handleClick}
                              />
                            </td>
                            <td>
                              <input
                                type="checkbox"
                                id={item.permissionid}
                                value="can_view_own"
                                checked={item.can_view_own || false}
                                onChange={handleClick}
                              />
                            </td>
                            <td>
                              <input
                                type="checkbox"
                                value="can_edit"
                                id={item.permissionid}
                                checked={item.can_edit || false}
                                onChange={handleClick}
                              />
                            </td>
                            <td>
                              <input
                                type="checkbox"
                                value="can_create"
                                id={item.permissionid}
                                checked={item.can_create || false}
                                onChange={handleClick}
                              />
                            </td>
                            <td>
                              <input
                                type="checkbox"
                                value="can_delete"
                                id={item.permissionid}
                                checked={item.can_delete || false}
                                onChange={handleClick}
                              />
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    <div className="text-center d-flex justify-content-center ">
                      <input className=" mb-2" type="submit" />
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </Modal>
        </div>

        <Pajination
          setPostPerPage={setPostPerPage}
          postPerpage={postPerpage}
          page={page}
          setPage={setPage}
          total={total}
        />
      </div>
      <ToastContainer />
    </div>
  );
};

export default StaffPermission;
